import { useState } from 'react'
import { CfoBrandMark, CfoSiteFooter, navigateTo } from '../cfo-site/CfoSiteShared'
import { BOOK_WORKING_SESSION_URL, connectApi } from '../connect/connectApi'
import '../connect/ConnectPage.css'
import { supportMailto } from './support'

export type SupportDeps = { triage: (text: string) => Promise<{ labels: string[] }> }
const DEFAULT_DEPS: SupportDeps = { triage: connectApi.supportTriage }

export function SupportPage({ deps = DEFAULT_DEPS }: { deps?: SupportDeps }) {
  const from = typeof window === 'undefined' ? null : new URLSearchParams(window.location.search).get('from') || document.referrer || null
  const userAgent = typeof navigator === 'undefined' ? null : navigator.userAgent
  const [text, setText] = useState('')
  const [labels, setLabels] = useState<string[]>([])
  // FE:C11 — signed-in requests are labelled (category, urgency) so they reach the right
  // person first. Signed out, or if triage fails, the email simply goes unlabelled.
  const triage = () => {
    if (!text.trim()) return setLabels([])
    deps.triage(text).then(result => setLabels(result.labels), () => setLabels([]))
  }
  return <div className="fg-connect">
    <nav className="fg-connect-nav">
      <a href="/" onClick={event => { event.preventDefault(); navigateTo('/') }}><CfoBrandMark sub="Support" /></a>
      <span><a href="/connect">Connect</a><a href="/playbooks">Playbooks</a></span>
    </nav>
    <main className="fg-connect-main">
      <header className="fg-connect-hero">
        <h1>Support</h1>
        <p>Real people who know accounting and FuseGrid. Most questions are answered the same business day.</p>
      </header>
      <div className="fg-connect-grid">
        <section className="fg-connect-card">
          <h2>Work through it together</h2>
          <p>Book a working session. We will connect your AI apps, set up a client workbook, or run a playbook with you on a real client.</p>
          <a className="fg-connect-button" href={BOOK_WORKING_SESSION_URL}>Book a working session</a>
        </section>
        <section className="fg-connect-card">
          <h2>Ask a question</h2>
          <p>Email us. The message already includes the page you came from, so you only need to say what went wrong.</p>
          <label className="fg-sr-only" htmlFor="fg-support-text">What went wrong?</label>
          <textarea id="fg-support-text" className="fg-support-text" placeholder="What were you trying to do, and what happened instead?"
            value={text} onChange={event => setText(event.target.value)} onBlur={triage} />
          <a className="fg-connect-button" href={supportMailto({ from, userAgent, text, labels })}>Email support</a>
        </section>
        <section className="fg-connect-card">
          <h2>Help yourself</h2>
          <ul>
            <li><a href="/connect">Connect Excel, Claude or ChatGPT</a></li>
            <li><a href="/playbooks">Step-by-step playbooks</a>, with practice on a demo company</li>
            <li><a href="/ai-activity">What the AI did</a> for any of your companies</li>
            <li><a href="/privacy">Privacy, AI connectors and subprocessors</a></li>
          </ul>
        </section>
      </div>
    </main>
    <CfoSiteFooter />
  </div>
}

export default SupportPage
